import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Divider } from 'semantic-ui-react'

import Waypoints from './Waypoints'

import { ProfilePicker } from 'components/profile-picker'
import { SettingsButton } from 'components/SettingsButton'
import { SettingsFooter } from 'components/SettingsFooter'
import { Settings } from './settings'
import { DateTimePicker } from 'components/DateTimePicker'
import { Button } from 'semantic-ui-react';

import {
  doAddWaypoint,
  doRemoveWaypoint,
  makeRequest,
  clearRoutes,
  //countValidWaypoints,
  //getValidWaypointCount,
} from 'actions/directionsActions'
import {
  updateProfile,
  doShowSettings,
  updatePermalink,
  resetSettings,
  doUpdateDateTime,
} from 'actions/commonActions'

class DirectionsControl extends React.Component {
  static propTypes = {
    profile: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    dateTime: PropTypes.shape({
      type: PropTypes.number,
      value: PropTypes.string,
    }),
    map: PropTypes.object, 
    activeLang: PropTypes.string.isRequired,
    geoJsonId: PropTypes.string,
    srcCoord: PropTypes.string,    
  }


  constructor(props) {
    super(props);
    this.state = {
      showDirectionButton: false,
    };
  }
    

  setShowDirectionButton = (value) => {
    this.setState({ showDirectionButton: value }, () => {
      //console.log("showDirectionButton updated:", this.state.showDirectionButton);
    });
  }
    
    

  handleUpdateProfile = (event, data) => {
    const { dispatch } = this.props
    dispatch(updateProfile({ profile: data.valhalla_profile }))
    dispatch(resetSettings())
    dispatch(updatePermalink())
  }

  handleAddWaypoint = (event, data) => {
    const { dispatch } = this.props
    dispatch(doAddWaypoint())
  }

  handleRemoveWaypoints = () => {
    const { dispatch } = this.props
    dispatch(doRemoveWaypoint())
    dispatch(clearRoutes())
  }



  componentDidUpdate() {
    /*
    if (prevState.showDirectionButton !== this.state.showDirectionButton) {
      console.log("DirectionsControl componentDidUpdate");
      console.log("showDirectionButton (in DirectionsControl):", this.state.showDirectionButton);
      // Force re-render if necessary
      this.forceUpdate();
    }*/
     // console.log("DirectionsControl componentDidUpdate");
  }
    

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props
    if (this.props.profile !== nextProps.profile) {
      dispatch(makeRequest())
    }
  }

  handleSettings = () => {
    const { dispatch } = this.props
    dispatch(doShowSettings())
  }

  handleDateTime = (type, value) => {
    const { dispatch } = this.props
    dispatch(doUpdateDateTime(type, value))
  }

  handleDirectionButtonOnClick = () => {    
    this.props.onCloseSidebar(); 
  }

  shouldComponentUpdate(nextProps) {
    const { dateTime, profile } = this.props
    const shouldUpdate =
      dateTime.type !== nextProps.dateTime.type ||
      dateTime.value !== nextProps.dateTime.value ||
      profile !== nextProps.profile
    if (shouldUpdate) {
      this.props.dispatch(makeRequest())
    }
    return shouldUpdate
  }


  shouldComponentUpdate(nextProps, nextState) {
    return true; 
  }

  render() {

    //console.log("Rendering DirectionsControl");

    const { profile, loading, dateTime, activeLang, showDirectionsPanel, onCloseSidebar } = this.props

    const popupContent = activeLang === 'zh' ? 
    [
      '步行',
      '駕駛',
    ]
    : 
    [
      'Walking',
      'Driving',
    ];   
    
    const showDirectionLabel = activeLang === 'zh' ? '顯示路線' : 'Show Way';

    return (      
      <React.Fragment>
        <div className="flex flex-column content-between">
          <div>
            {/* Hide the selection
            <div className="pa2 flex flex-row justify-between">
              <ProfilePicker
                group={'directions'}
                profiles={[
                  'pedestrian',
                  'car',
                ]}
                loading={loading}
                popupContent={popupContent}
                activeProfile={profile}
                handleUpdateProfile={this.handleUpdateProfile}
              />             
            </div>
            */}
            <div className="flex flex-wrap justify-between">
              <Waypoints 
                map={this.props.map}
                activeLang={this.props.activeLang} 
                geoJsonId={this.props.geoJsonId} 
                srcCoord={this.props.srcCoord}
                showDirectionButton={this.state.showDirectionButton}
                setShowDirectionButton={this.setShowDirectionButton}                
              />
            </div>
            <div align="center">
            {this.state.showDirectionButton && (
            <Button
                primary
                style={{
                  backgroundColor: 'darkgreen',
                  width: '135px',
                  height: '35px',
                  padding: 0,
                  margin: '10px',
                  border: '2px solid darkgreen',
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',                  
                }}
                onClick={this.handleDirectionButtonOnClick}
              >{showDirectionLabel}</Button>
            )}
            </div>
            <div className="pa2 flex flex-wrap justify-between">
              <Settings
                handleAddWaypoint={this.handleAddWaypoint}
                handleRemoveWaypoints={this.handleRemoveWaypoints}
              />
            </div>            
          </div>                 
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  const { profile, loading, dateTime, activeLang, geoJsonId, srcCoord, showDirectionsPanel } = state.common
  return {
    profile,
    loading,
    dateTime,
    activeLang,
    geoJsonId,
    srcCoord,
    showDirectionsPanel,     
  }
}

export default connect(mapStateToProps)(DirectionsControl)
